import styles from './styles.module.scss';
import firstStepStyles from '../../styles.module.scss';
import { useTranslates } from 'providers/translates';
import { Language } from 'providers/translates/enums';
import { isVac } from "utilities/is-vac";


export const TributesInfo: React.FC = () => {
  const { translates: t, selectedLang } = useTranslates();
  const isFrench = selectedLang === Language.FRENCH;
  const tributesPermissions = t?.quiltBuilderStepOne?.tributesPermissions;

  return (
    <div className={styles.tributes__info}>
      <span className={styles.tributes__title}>{tributesPermissions?.tributesPermissionsHeading ?? 'Tributes and condolences'}</span>
      <p className={firstStepStyles.startText}>
        {tributesPermissions?.tributesIntroductionText ?? (
          <>
            Select “Allow tributes and condolences” if you want visitors to leave comments. Anyone
            viewing your quilt square will see these tributes and condolences. You will be able to
            remove any condolences from your published quilt square.
          </>
        )}
      </p>
      {!isVac() ? null : (
        isFrench ? (
          <img
            className={styles.tributes__img}
            src="/img/general/sharing-picture-4.png"
            alt="line"
          />
        ) : (
          <img
            className={styles.tributes__img}
            src="/img/general/sharing-picture-3.png"
            alt="line"
          />
        )
      )}      
    </div>
  );
}
